import ApplicationSerializer from 'cio/serializers/application';
import DS from 'ember-data';

const { EmbeddedRecordsMixin } = DS;

export default class SegmentSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    tags: { serialize: 'ids' },
    createdByUser: {
      serialize: false,
      deserialize: 'records',
    },
    updatedByUser: {
      serialize: false,
      deserialize: 'records',
    },
    usage: {
      serialize: false,
    },
  },
}) {}
